class BespokeCTA extends HTMLElement {
  constructor() {
    super();

    this.querySelectorAll('.js-modal-trigger').forEach((trigger) => {
      trigger.addEventListener('click', this.open.bind(this));
    });

    this.querySelectorAll('.js-modal-close').forEach((icon) => {
      icon.addEventListener('click', this.close.bind(this));
    });

    this.querySelector('.js-modal')?.addEventListener('click', (e) => {
      if (e.target === this.querySelector('.js-modal')) this.close(e);
    });

    this.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.querySelector('.bespoke-cta__modal--open')) this.close(event);
    });

    this.addEventListener('cart:update', () => {
      if (this.querySelector('.bespoke-cta__modal--open')) this.close();
    });

    if (this.dataset.bespokeProduct === 'true') {
      const submitBtn = document.querySelector('.product-form__submit');
      if (submitBtn) submitBtn.addEventListener('click', (e) => this.openProductModal(e));
    }
  }

  openProductModal(event) {
    const modal = this.querySelector('.bespoke-cta__modal');
    if (!modal) return;
    modal.classList.add('bespoke-cta__modal--open');
    modal.classList.remove('hidden');
    modal.setAttribute('aria-hidden', 'false');
    const firstInner = this.querySelector('.js-modal-inner');
    if (firstInner) firstInner.classList.remove('hidden');
    this.querySelector('.js-modal-close')?.focus({ preventScroll: true });
    this.scrollIntoView({ behavior: 'smooth' });
  }

  open(event) {
    event.preventDefault();
    const triggerEl = event.target.closest('.js-modal-trigger') || event.target;
    const triggerType = triggerEl.dataset?.trigger;
    if (!triggerType) return;

    const inner = Array.from(this.querySelectorAll('.js-modal-inner')).find(
      (item) => item.dataset.trigger === triggerType
    );
    if (inner) inner.classList.remove('hidden');

    const modal = this.querySelector('.js-modal');
    if (modal) {
      modal.classList.add('bespoke-cta__modal--open');
      modal.classList.remove('hidden');
      modal.setAttribute('aria-hidden', 'false');
    }
    document.body.style.overflow = 'hidden';
    this.querySelector('.js-modal-close')?.focus({ preventScroll: true });
  }

  close(event) {
    if (event) event.preventDefault();
    this.querySelectorAll('.js-modal-inner').forEach((modal) => modal.classList.add('hidden'));
    const modal = this.querySelector('.js-modal');
    if (modal) {
      modal.classList.remove('bespoke-cta__modal--open');
      modal.classList.add('hidden');
      modal.setAttribute('aria-hidden', 'true');
    }
    document.body.style.overflow = '';
  }
}
if (!customElements.get('bespoke-cta')) customElements.define('bespoke-cta', BespokeCTA);
